import { Component } from '@angular/core';
import { ConnectivityService } from '../../services/connectivity-checks.service';

@Component({
    selector: 'app-no-connectivity',
    templateUrl: './no-connectivity.component.html',
    styleUrl: './no-connectivity.component.scss',
})
export class NoConnectivityComponent {
    constructor(private connectivityService: ConnectivityService) {}
}
